import React from 'react';

import { Client, Company } from 'src/constants';
import { selectActiveCompaniesMap } from 'src/store/clients/types';

import { useAppSelector } from './useStore';

export const useClientCompanies = (
  client: Client | null | undefined,
): Company[] => {
  const activeCompaniesMap = useAppSelector(selectActiveCompaniesMap);

  return React.useMemo(() => {
    if (!client) return [];

    return (client.fields?.companyIds || [])
      .map((id) => activeCompaniesMap.get(id))
      .filter((company): company is Company => company !== undefined)
      .sort(
        (a, b) =>
          new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime(),
      );
  }, [client, activeCompaniesMap]);
};
